<template>
    <span class="text-danger" v-if="mostrarBtn">
        <i
            class="fa fa-trash fa-lg icon-button ml-2"
            title="Excluir entrega manual"
            @click.stop="confirmarExcluir()"
        ></i>
    </span>
</template>

<script>
import { entregaStatus } from './EntregaStatus'

export default {
    props: {
        contratacao: {
            type: Object,
            default: () => ({})
        },

        entrega: {
            type: Object,
            default: () => ({})
        },

        contratacoesServicos: {
            type: Object,
            required: true,
            default: () => ({})
        }
    },

    data() {
        return {}
    },

    methods: {
        confirmarExcluir() {
            this.$swal({
                title: 'Exclusão de Entrega Manual',
                html: `Confirma a exclusão da entrega manual <b>${this.entrega.descritivo}</b>?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.excluir()
                }
            })
        },

        excluir() {
            this.$store.dispatch('addRequest')
            this.contratacoesServicos
                .excluirEntregaManual(
                    this.contratacao.codContratacao,
                    this.entrega.entregaId
                )
                .then(response => {
                    if (response) {
                        if (response.success) {
                            this.$toast.success(
                                'Registro excluído com sucesso!',
                                'OK',
                                this.$toastConfig.success
                            )
                            this.$emit('obterAtualizacao')
                        } else {
                            this.$toast.error(
                                'Erro ao excluir entrega.',
                                'ERROR',
                                this.$toastConfig.error
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
        }
    },

    computed: {
        mostrarBtn() {
            return (
                this.$temAcesso('CRED-UABS-ENTR-05') &&
                this.entrega.manual &&
                (this.entrega.status === entregaStatus.EM_ABERTO ||
                    this.entregas.status === entregaStatus.REPROVADA)
            )
        }
    }
}
</script>
